export default __webpack_public_path__ + "static/award-2023-ddbb1e9820ba74fd05f40793fdc7b78c.jpg";